export interface SystemLogPayloadFilterModel {
    UserName: string;
    FormName: string;
    ActionType?: number | null;
    FromDate?: Date | null;
    ToDate?: Date | null;
}


export class SystemLogModel {
    tableSysname: string;
    formName: string;
    actionType: number;
    actionTitle: string;
    createDate: string;
    userId: number;
    userName: string;

    constructor(
        tableSysname: string,
        formName: string,
        actionType: number,
        actionTitle: string,
        createDate: string,
        userId: number,
        userName: string
    ) {
        this.tableSysname = tableSysname;
        this.formName = formName;
        this.actionType = actionType;
        this.actionTitle = actionTitle;
        this.createDate = createDate;
        this.userId = userId;
        this.userName = userName;
    }

    public static fromJson(json: any): SystemLogModel {
        return new SystemLogModel(
            json["tableSysname"],
            json["formName"],
            json["actionType"],
            json["actionTitle"],
            json["createDate"],
            json["userId"],
            json["userName"]
        );
    }
}
